export function timeParserOneElement(element) {
  let year,month, day, h, min, sec;
  /* tsEvent
  2020-01-17 15:31:07.0*/
  year = element.tsEvent.substring(0, 4);
  month = element.tsEvent.substring(5, 7);
  day = element.tsEvent.substring(8, 10);
  h = element.tsEvent.substring(11, 13);
  min = element.tsEvent.substring(14, 16);
  sec = element.tsEvent.substring(17, 19);
  element.tsEvent = day + "." + month + "." + year + " " + h + ":" + min;
  /* tsBooked */
  year = element.tsBooked.substring(0, 4);
  month = element.tsBooked.substring(5, 7);
  day = element.tsBooked.substring(8, 10);
  h = element.tsBooked.substring(11, 13);
  min = element.tsBooked.substring(14, 16);
  sec = element.tsBooked.substring(17, 19);
  element.tsBooked = day + "." + month + "." + year + " " + h + ":" + min;
  /* nextContact */
  year = element.nextContact.substring(0, 4);
  month = element.nextContact.substring(5, 7);
  day = element.nextContact.substring(8, 10);
  element.nextContact = day + "." + month + "." + year;


return element;
}
